import { render, staticRenderFns } from "./myFocusOn.vue?vue&type=template&id=1cae8275&scoped=true&"
import script from "./myFocusOn.vue?vue&type=script&lang=js&"
export * from "./myFocusOn.vue?vue&type=script&lang=js&"
import style0 from "./myFocusOn.vue?vue&type=style&index=0&id=1cae8275&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cae8275",
  null
  
)

export default component.exports